import { Box } from '@mui/material';
import SearchField from 'components/controls/SearchField';
import { func, string } from 'prop-types';
import React from 'react';

const Search = ({ value = '', onChange }) => (
  <Box sx={{ display: 'flex', alignItems: 'center' }}>
    <SearchField onChange={onChange} value={value} />
  </Box>
);

Search.propTypes = {
  value: string,
  onChange: func.isRequired,
};

export default Search;
